<template>
  <ServiceCard 
    title="Application Development"
    subtitle="Custom software solutions"
    description="Full-stack development services to build robust, scalable applications for your business."
    to="/services/application-development"
    gradient-start="#ff9500"
    gradient-end="#ff6b00"
    button-text="Learn More"
  />
</template>

<script setup>
import ServiceCard from '~/components/ServiceCard.vue';
</script>